/*
 *  -----------------------------------------------------------------------
 *    <copyright file="crfs-svt-grid.data.ts" company="Triumph Research Intelligence">
 *        Copyright (C) 2023 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import { GridColumnMenuActiveFilter } from '@components/core/grid-filters';
import { useGridCells } from '@hooks/index';
import { GridColumnDateFilterV2 } from '@components/core/grid-filters-v2';

const { YesNoCell, NumberCell, DateCell, MaxLengthCell } = useGridCells();

export const CRFS_SVT_GRID_COLUMNS = (translate: Function) => [
    {
        field: 'subjectCode',
        id: 'schedule-crf-subjectCode',
        label: translate('admin:formId'),
        minWidth: 200,
        cells: { data: MaxLengthCell(50) },
    },

    {
        field: 'crfName',
        id: 'schedule-crf-crfName',
        label: translate('common:name'),
        minWidth: 140,
        cells: { data: MaxLengthCell(50) },
    },
    {
        field: 'required',
        id: 'schedule-crf-required',
        label: translate('ra:required'),
        minWidth: 155,
        cells: { data: YesNoCell },
        filterUi: GridColumnMenuActiveFilter,
    },
    {
        field: '_assessmentsTitles',
        label: translate('admin:assessmentS'),
        minWidth: 200,
        id: 'schedule-crf-assessments',
        cells: { data: MaxLengthCell(50) },
    },
    {
        field: 'active',
        id: 'schedule-crf-active',
        label: translate('admin:active'),
        minWidth: 155,
        cells: { data: YesNoCell },
        filterUi: GridColumnMenuActiveFilter,
    },
    {
        field: '_crfRules',
        id: 'crf-additional-rules',
        label: translate('ra:additionalRules'),
        minWidth: 155,
        cells: { data: MaxLengthCell(50) },
    },
    {
        label: translate('ra:createdBy'),
        id: 'schedule-crf-createdby',
        field: '_createdByString',
        minWidth: 180,
    },
    {
        label: translate('ra:createdDate'),
        id: 'schedule-crf-created',
        minWidth: 200,
        field: 'created',
        cells: { data: DateCell },
        filter: 'date',
        filterUi: GridColumnDateFilterV2,
    },
    {
        label: translate('ra:updatedBy'),
        id: 'schedule-crf-updatedby',
        field: '_updatedByString',
        minWidth: 180,
    },
    {
        label: translate('ra:updatedDate'),
        field: 'updated',
        id: 'schedule-crf-updated',
        minWidth: 200,
        filter: 'date',
        cells: { data: DateCell },
        filterUi: GridColumnDateFilterV2,
    },
    {
        label: translate('id'),
        field: 'recordId',
        minWidth: 120,
        id: 'schedule-crf-id',
        filter: 'numeric',
        cells: { data: NumberCell },
        showByDefault: false,
    },
];
